var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true}}],attrs:{"id":"app","element-loading-text":_vm.loadingText,"element-loading-spinner":"el-icon-loading"}},[_c('TransitionFadeComponent',[_c('router-view')],1),_c('SigningToastQueue'),_c('CopilotModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }